"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_outputs-tab.scss");

var _status = _interopRequireDefault(require("../../../../../constants/status"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getLatestVersion(_ref) {
  var versions = _ref.versions,
      statusName = _ref.statusName;

  if (statusName === 'PENDING_MASTER') {
    return 'N/A';
  }

  return versions.reduce(function (latestNumber, version) {
    return version.versionNumber > latestNumber ? version.versionNumber : latestNumber;
  }, 1);
}

function OutputsTab(_ref2) {
  var selectedOutputId = _ref2.selectedOutputId,
      outputs = _ref2.outputs,
      gotoOutput = _ref2.gotoOutput;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "outputs-tab"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Related Outputs (".concat(outputs.length - 1, ")")), outputs.filter(function (_ref3) {
      var outputId = _ref3.outputId;
      return outputId !== selectedOutputId;
    }).map(function (_ref4) {
      var outputId = _ref4.outputId,
          name = _ref4.name,
          aspectRatio = _ref4.aspectRatio,
          isMaster = _ref4.isMaster,
          status = _ref4.status,
          versions = _ref4.versions;
      return (/*#__PURE__*/_react.default.createElement("div", {
          key: outputId
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-tab__title"
        }, isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "master",
          color: "goldenTainoi"
        }) : null, /*#__PURE__*/_react.default.createElement("h3", null, name || aspectRatio)), /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-tab__section"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-tab__section__row"
        }, /*#__PURE__*/_react.default.createElement("h4", null, "Status"), /*#__PURE__*/_react.default.createElement("p", null, _status.default[status.name])), /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-tab__section__row"
        }, /*#__PURE__*/_react.default.createElement("h4", null, "Video"), /*#__PURE__*/_react.default.createElement("p", null, "#".concat(outputId))), /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-tab__section__row"
        }, /*#__PURE__*/_react.default.createElement("h4", null, "Output"), /*#__PURE__*/_react.default.createElement("p", null, aspectRatio)), /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-tab__section__row"
        }, /*#__PURE__*/_react.default.createElement("h4", null, "Version"), /*#__PURE__*/_react.default.createElement("p", null, getLatestVersion({
          versions: versions,
          statusName: status.name
        })))), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          className: "outputs-tab__view-video",
          disabled: status.name === 'PENDING_MASTER',
          small: true,
          onClick: gotoOutput(outputId)
        }, "VIEW VIDEO"))
      );
    }))
  );
}

var _default = (0, _react.memo)(OutputsTab);

exports.default = _default;